import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { templateSettingsForm } from '../view/template';
import { PackageSettingsFormWebComponent } from '../component/PackageSettingsFormWebComponent';
import { PackageSettingsFormView } from '../view/PackageSettingsFormView';
import { InputEvents } from '../../../../ui/gzInput/types';
import { ServiceTargetIds } from '../../../../targets/type';
import { SelectedTarget, SettingsFormViewMetadata } from '../types/PackageSettingsFormViewData';

export class PackageSettingsFormController extends BaseWebComponentController {
  public component: PackageSettingsFormWebComponent;
  public view: PackageSettingsFormView;
  public viewConstructor: typeof PackageSettingsFormView;

  constructor(component: PackageSettingsFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: PackageSettingsFormView,
      viewTemplate: templateSettingsForm,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$useCustomPathCheckbox,
        event: InputEvents.CHANGE,
        callback: event => {
          this.view.onCustomPathCheckboxChanged(event.detail.checked);
        },
      },
      {
        element: this.view.dom.$setUninstallPasswordCheckbox,
        event: InputEvents.CHANGE,
        callback: event => {
          this.view.onUninstallPasswordCheckboxChanged(event.detail.checked);
        },
      },
      {
        element: this.view.dom.$useCustomFoldersCheckbox,
        event: InputEvents.CHANGE,
        callback: event => {
          this.view.onUseCustomFoldersChange(event.detail.checked).then().catch(console.error);
        },
      },
      {
        element: this.view.dom.$settingsPasswordInput,
        event: InputEvents.CHANGE,
        callback: event => {
          this.view.onPasswordInputChange();
        },
      },
      {
        element: this.view.dom.$settingsConfirmPasswordInput,
        event: InputEvents.CHANGE,
        callback: () => {
          if (this.view.dom.$settingsPasswordInput.value !== this.view.dom.$settingsConfirmPasswordInput.value) {
            this.view.onPasswordInputChange();
            this.view.formGroup.validate(true);
          }
        },
      },
    ];
  }

  public getSelectedTargets(): SelectedTarget | null {
    if (!this.view.dom.$useCustomFoldersCheckbox.Input.checked) {
      return null;
    }

    const selectedTargets: SelectedTarget = {
      epsFolder: {
        notSet: true,
      },
      sveFolder: {
        notSet: true,
      },
    };
    const selectedNodes = this.view.dom.$settingsTargets.getSelectedTargets();
    selectedNodes.forEach(target => {
      const serviceTarget = {
        company: target.targets[0].company,
        protectedEntityId: target.targets[0].protectedEntityId,
        name: target.targets[0].name,
        type: target.targets[0].type,
        path: target.targets[0].path,
        notSet: false,
      };

      if (target.serviceId === ServiceTargetIds.EPS) {
        selectedTargets['epsFolder'] = serviceTarget;
      }

      if (target.serviceId === ServiceTargetIds.SVE) {
        selectedTargets['sveFolder'] = serviceTarget;
      }
    });
    return selectedTargets;
  }

  public async enableSettingsSection(): Promise<void> {
    await this.render();
    this.view.enableDisableSettingsSection(false);
  }

  async getDataForView(): Promise<SettingsFormViewMetadata> {
    return {
      companyId: this.component.companyId,
      settingsFormData: this.component.getPackageData(),
      packageType: this.component.getPackageType(),
    };
  }
}
